module.exports = __webpack_public_path__ + "img/38_30.d803d0aa.png";